import './PageContentTransition.css';
import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import SeptimLoadingSpinner from '../Manager/SeptimLoadingSpinner/SeptimLoadingSpinner';
import { useTranslate } from '../../hooks/context/useTranslate';

interface PageContentTransitionProps {
  isVisible: boolean;
}

const PageContentTransition = ({ isVisible }: PageContentTransitionProps) => {
  const { t } = useTranslate();
  const [runId, setRunId] = useState(0);
  const wasVisibleRef = useRef(false);

  // Remount the spinner on each show (rising edge of isVisible) so the gif is
  // refetched and restarts from frame 0. The element stays mounted while hiding
  // so the fade-out keeps painting the spinner.
  useEffect(() => {
    if (isVisible && !wasVisibleRef.current) {
      setRunId((id) => id + 1);
    }

    wasVisibleRef.current = isVisible;
  }, [isVisible]);

  return (
    <div
      className={clsx('page-content-transition', isVisible && 'is-visible')}
      aria-hidden={!isVisible}
      aria-label={t('loading')}
      role="status"
    >
      <SeptimLoadingSpinner key={runId} />
    </div>
  );
};

export default PageContentTransition;
